export default {
  errors: {
    emailAlreadyRegistered:
      'Email déjà enregistré, veuillez essayer de vous connecter.',
    invalidEmail: 'Email invalide, veuillez réessayer.'
  },
  title: 'Inscription',
  subtitle: 'Créez un nouveau compte Vamoz',
  success: {
    title: 'Vérifiez votre email ✉️',
    message:
      "Nous vous avons envoyé un email avec un lien pour vérifier votre compte. L'email peut prendre quelques minutes pour arriver. Veuillez également vérifier votre dossier spam."
  },
  confirmation: {
    confirmed: {
      title: 'Email confirmé !',
      message:
        'Votre adresse email a été confirmée. Vous pouvez maintenant vous connecter à Vamoz.'
    },
    alreadyConfirmed: {
      title: 'Lien déjà utilisé',
      message:
        'Ce lien de confirmation a déjà été utilisé ou est en cours de traitement. Si votre compte est prêt, vous pouvez vous connecter ci-dessous.'
    },
    expired: {
      title: 'Lien de confirmation expiré',
      message:
        "Revenez au lien d'inscription de votre entreprise et saisissez à nouveau votre email. Contactez votre administrateur si vous n'avez plus ce lien."
    },
    invalid: {
      title: 'Lien de confirmation invalide',
      message:
        "Ouvrez le dernier email de confirmation reçu ou demandez-en un nouveau depuis le lien d'inscription de votre entreprise."
    },
    unavailable: {
      title: 'Confirmation temporairement indisponible',
      message:
        'Réessayez ce lien dans quelques minutes. Contactez le support si le problème persiste.'
    }
  },
  goToLogin: 'Aller à la connexion',
  button: "S'inscrire",
  allowedDomains: 'Domaines autorisés : {domains}',
  help: 'Aide',
  instructions: {
    title: "Instructions d'inscription",
    subtitle: 'Veuillez suivre ces trois étapes pour vous inscrire à Vamoz.',
    step1: "Entrez votre adresse email (d'un domaine autorisé)",
    step2:
      'Vérifiez votre email (cela peut prendre quelques minutes pour arriver)',
    step3:
      "Cliquez sur le lien dans l'email pour confirmer votre adresse email",
    spamFolder:
      "Si vous ne voyez pas l'email dans votre boîte de réception, veuillez vérifier votre dossier spam."
  }
};
